// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__uF+yR","label":"default_label__86013","fields":"default_fields__67yEt","field":"default_field__q8muA","separator":"default_separator__YsH82"};